import tw from "twin.macro";

export const SectionHeading = tw.h1`text-4xl text-black sm:text-5xl text-gray-800 tracking-wide text-center`
export const Subheading = tw.h5`font-bold text-primary-500`
